import type { ICloudbase } from '@cloudbase/types'
import type { ICloudbaseComponent } from '@cloudbase/types/component'
import { generateApis } from './callApis'

declare const cloudbase: ICloudbase

const COMPONENT_NAME = 'apis'

const component: ICloudbaseComponent = {
  name: COMPONENT_NAME,
  IIFE: true,
  entity() {
    Object.defineProperty(this.prototype, COMPONENT_NAME, {
      get() {
        // 这里的 this 是 cloudbase 实例
        return generateApis.call(this)
      },
      configurable: true,
      enumerable: true,
    })
  },
}

function registerApis(app: ICloudbase) {
  try {
    app.registerComponent(component)
  } catch (e) {
    console.warn(e)
  }
}

try {
  cloudbase.registerComponent(component)
} catch (e) {
}

export { generateApis, registerApis }
export * from './type'

try {
  (window as any).registerApis = registerApis
} catch (e) {}
